import { logEvent } from "firebase/analytics";
import { analytics } from "./firebase/config";

/** GA4 이벤트 하나.
 *
 *  실패는 삼킨다 — 지표가 기능을 막으면 안 된다(`reportDrawUsage` ·
 *  `PUT /users/me` 와 같은 원칙). 광고 차단기가 gtag 를 막는 게 정상 케이스다.
 *
 *  `page_view` · `session_start` · `first_visit` 과 utm 파싱은 GA4 가 알아서
 *  한다. 여기서 직접 쏘지 말 것 — 두 벌이 된다.
 *
 *  **사람을 가리키는 값을 넘기지 않는다**(`feature_events` 와 같은 규칙).
 *  이름·이메일·워크스페이스 id 는 GA4 에 올리지 않는다. 세는 데 필요한 축만.
 *
 *  기능 사용량(건배사·내기 횟수)도 여기로 보내지 않는다. 그건 서버의
 *  `feature_events` 가 이미 세고 그쪽이 진실값이다 — GA 는 문 앞(유입·이탈)만
 *  본다. 광고 차단으로 10~30% 덜 잡히는 숫자를 사용량이라고 부르면 안 된다. */
export function track(name: string, params?: Record<string, string | number>): void {
  void analytics.then((a) => a && logEvent(a, name, params)).catch(() => undefined);
}
